import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationItem {
  id: number;
  type: NotificationType;
  message: string;
}

interface NotificationState {
  items: NotificationItem[];
  push: (type: NotificationType, message: string) => void;
  dismiss: (id: number) => void;
}

let _counter = 0;

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  push: (type, message) => {
    const id = ++_counter;
    set((state) => ({ items: [...state.items, { id, type, message }] }));
  },
  dismiss: (id) => set((state) => ({ items: state.items.filter(i => i.id !== id) })),
}));

// API ergonômica para substituir alert(...) a partir de qualquer lugar (componente ou não).
export const notify = {
  success: (message: string) => useNotificationStore.getState().push('success', message),
  error: (message: string) => useNotificationStore.getState().push('error', message),
  warning: (message: string) => useNotificationStore.getState().push('warning', message),
  info: (message: string) => useNotificationStore.getState().push('info', message),
};
